import {Form} from './form';
import {FormTypes} from './form-types';

export class CustomForm extends Form {
    type = FormTypes.Custom;
    constructor() {
        super();
    }
}
